// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__GgG2T","loadingOverlay":"Detail_loadingOverlay__TIvaj"};